/**
 * ShopSales Component
 * --
 * 작성자 - Owen
 * 작성일 - 2025 07 11 금요일
 * 마지막 수정일 - 2025 07 16 수요일
 */
import React from 'react';
import { Table } from 'antd';
import { Content } from 'components';
import { PAYMENT_METHOD_CONSTANT } from 'constants/ProductConstants';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import ShopSalesDetail from './ShopSalesDetail';

const ShopSales = (props) => {
  /**
   * SECTION - Props
   */
  const {
    type = 'daily',
    columns = [],
    data = [],
    setTableColumns = () => {},
    disabled = [],
    shopId = null,
  } = props;
  /**!SECTION - Props */

  /**
   * SECTION - State
   */
  const [isOpened, setIsOpened] = React.useState(null);
  const [summaryData, setSummaryData] = React.useState(null);
  /**!SECTION - State */

  /**
   * SECTION - Function
   */
  const setData = React.useCallback(
    (d) => setTableColumns(d),
    [setTableColumns],
  );
  /**!SECTION - Function */

  /**
   * SECTION - Hooks
   */
  const Columns = React.useMemo(() => {
    let col = [];

    switch (type) {
      case 'daily': {
        col = [
          {
            title: '날짜',
            key: 'key',
            dataIndex: 'key',
            fixed: 'left',
            render: (item) =>
              dayjs(item).locale('ko').format('YYYY-MM-DD (dd)'),
          },
          ...columns,
        ];
        break;
      }
      case 'products': {
        col = [
          {
            title: '상품명',
            key: 'key',
            dataIndex: 'key',
            fixed: 'left',
          },
          ...columns,
        ];
        break;
      }
      case 'timezone': {
        col = [
          {
            title: '시간대',
            key: 'key',
            dataIndex: 'key',
            fixed: 'left',
            render: (item) => `${item}:00 ~ ${item}:59`,
          },
          ...columns,
        ];
        break;
      }
      case 'payments': {
        col = [
          {
            title: '결제수단',
            key: 'key',
            dataIndex: 'key',
            fixed: 'left',
            render: (item) => PAYMENT_METHOD_CONSTANT[item]?.title,
          },
          ...columns,
        ];
        break;
      }
      case 'category': {
        col = [
          {
            title: '카테고리명',
            key: 'key',
            dataIndex: 'key',
            fixed: 'left',
          },
          ...columns,
        ];
        break;
      }
      default: {
        return [];
      }
    }

    return col;
  }, [type, columns]);

  // 숨김 컬럼에 따른 새로운 컬럼 정제
  const NewColumns = React.useMemo(() => {
    if (!disabled.length) return [];

    return Columns.filter((item) => {
      if (item.key === 'key') return true;
      else return disabled.includes(item.key);
    });
  }, [Columns, disabled]);

  React.useEffect(() => {
    // 엑셀 다운로드 컬럼도 현재 화면에 표시된 컬럼과 동일하게 맞춥니다.
    setData(NewColumns);
  }, [setData, NewColumns]);
  /**!SECTION - Hooks */
  /**
   * SECTION - Render
   */

  return (
    <React.Fragment>
      <Content maxWidth={'100%'} padding={0}>
        <Table
          size='small'
          bordered
          columns={NewColumns}
          dataSource={data}
          locale={{
            emptyText: '검색된 판매 데이터가 없습니다',
          }}
          pagination={false}
          scroll={{ x: 200 * NewColumns.length, y: 700 }}
          {...(type === 'daily'
            ? {
                onRow: (record) => {
                  return {
                    onClick: () => {
                      setIsOpened(record.key);
                      setSummaryData(record);
                    },
                  };
                },
              }
            : {})}
        />
      </Content>

      <ShopSalesDetail
        open={!!isOpened}
        onClose={() => setIsOpened(null)}
        date={isOpened}
        shopId={shopId}
        summary={summaryData}
      />
    </React.Fragment>
  );
  /**!SECTION - Render */
};

export default ShopSales;
